/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { P as Picker, d as defineCustomElement$1 } from './picker.js';
const IonPicker = Picker;
const defineCustomElement = defineCustomElement$1;
export { IonPicker, defineCustomElement };